import { render, staticRenderFns } from "./generalcomments.vue?vue&type=template&id=15856d9f&"
import script from "./generalcomments.vue?vue&type=script&lang=js&"
export * from "./generalcomments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports